<template>
  <div class="ac2">
    <!-- 标题 -->
    <div class="ac2-title">
      <!-- <h2>图书信息</h2> -->
      {{ msrc }}
    </div>

    <!-- 循环项 -->
    <div
      class="ac2-item"
      v-for="(item, index) in dataa"
      :key="index"
      @click="goDays(item.methods, item.id)"
    >
      <!-- 左侧图片 -->
      <div class="item-img">
        <img :src="item.img" alt="" />
      </div>
      <!-- 右侧信息 -->
      <div class="item-info">
        <!-- 标题 -->
        <div class="item-title">
          {{ item.title }}
        </div>
        <!-- 简介 -->
        <div class="item-jj">
          {{ item.jj }}
        </div>
       
        <p><i class="iconfont icon-moban"></i> {{ item.sub }} <span style="margin-left:30px;"> {{ item.pay }}</span> </p>
        <!-- 时间 -->
        <!-- <div class="item-time">发布时间：{{ item.time }}</div> -->
      </div>
    </div>
    <modal
      title="请选择支付方式"
      btnType="1"
      modalType="middle"
      :showModal="showModal"
      @submit="showModal = false"
      @cancel="showModal = false"
    >
      <template v-slot:body>
        <img
          style="display: flex; justify-content: center; margin: 0 auto"
          src="/imgs/pay2.png"
        />
        <h2>微信支付：2元/篇</h2>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from "./../components/Modal";
export default {
  name: "ac2",
  props: {
    msrc: String,
    mtitle: String,
  },
  components: {
    Modal,
  },
  data() {
    return {
      dataa: [],
      // 获取到 user 用户信息
      nv_user: JSON.parse(window.localStorage.getItem("user")),
      // 存储状态
      state: JSON.parse(window.localStorage.getItem("state")),
      showModal: false,
    };
  },
  mounted() {
    this.init();
 
  },
  methods: {
    init() {
      this.axios.get("/mock/ac1.json").then((res) => {
        const data = res.data;
        // 两条数据
        this.dataa = data.splice(0, 10);
        // console.log(this.data);
      });
    },
    // 跳转 逻辑 封装
    goDays(methods, id) {
      this[methods](id);
    },
    // 收费逻辑
    gopay() {
      alert("资讯收费2元，请扫码购买~");
       this.showModal = true;
    },
    // 跳转详情页
    goDetails(id) {
      this.$router.push({
        path: "/sound/:" + id,
        query: { type: id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.ac2 {
  width: 100%;
  //   height: 400px;
  // background-color: pink;
  // 标题
  .ac2-title {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #ccc;
    // padding-left: 30px;
    box-sizing: border-box;
    h2 {
      font-size: 16px;
      width: 80px;
      height: 100%;
      line-height: 40px;
      text-align: center;
      border-bottom: 1px solid $colorZ;
    }
  }
  // 循环线
  .ac2-item {
    width: 100%;
    height: 180px;
    // background-color: #c60023;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    // 左侧图片
    .item-img {
      width: 300px;
      height: 100%;
      margin-right: 20px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    // 右侧信息
    .item-info {
      //   width: 70%;
      width: 400px;
      //   background-color: #ff6600;
      padding: 15px;
      box-sizing: border-box;
      //   height: 100%;
      //   标题
      .item-title {
        font-size: 18px;
        color: #121212;
        cursor: pointer;
        &:hover {
          color: $colorZ;
        }
      }
      // 简介
      .item-jj {
        width: 100%;
        // height: 45px;
        font-size: 14px;
        color: #555;
        margin: 15px auto;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }
      //   时间
      .item-time {
        font-size: 12px;
        color: #888;
      }
      p {
        font-size: 12px;
        color: #888;
        i {
          font-size: 18px;
          margin-right: 5px;
        }
      }
    }
  }
}
</style>